<template>
    <v-container class="pa-0" fluid fill-height>
        <v-layout row wrap>
            <v-flex xs12 sm6>
                <v-select
                        label="Typ"
                        :items="starter_types"
                        :disabled="loadingSubmit || loadingTypes || starter_types.length === 1"
                        :loading="loadingTypes"
                        item-value="id"
                        item-text="name"
                        v-model="selectedType"
                        return-object
                        chips
                        @input="starterTypeChanged"
                        required
                >
                    <template slot="selection" slot-scope="data">
                        <v-chip
                                @input="data.parent.selectItem(data.item)"
                                :selected="data.selected"
                                :key="JSON.stringify(data.item)"
                                :disabled="data.disabled"
                        >{{ $t(data.item.name) }}</v-chip>
                    </template>
                    <template
                            slot="item"
                            slot-scope="data"
                    >
                        <v-list-tile-content v-t="data.item.name"></v-list-tile-content>
                    </template>
                </v-select>
            </v-flex>
            <v-flex xs12 sm6>
                <v-select
                        :label="'Altersklasse/n'"
                        :disabled="age_groups.length < 2 || loadingAgeGroups"
                        :loading="loadingAgeGroups"
                        :items="age_groups"
                        item-value="id"
                        item-text="name"
                        v-model="selectedAgeGroup"
                        return-object
                        chips
                        @input="ageGroupChanged"
                ></v-select>
            </v-flex>
            <v-flex xs12>
                <v-scale-transition>
                    <v-select
                            v-if="selectedType !== null && selectedType.has_styles && selectedAgeGroup !== null"
                            label="Styles"
                            :disabled="event_styles.length === 1 || selectedAgeGroup === null || loadingStyles || loadingAgeGroups || loadingSubmit"
                            :loading="loadingStyles"
                            :items="event_styles"
                            item-value="id"
                            item-text="style_name"
                            v-model="selectedEventStyles"
                            multiple
                            chips
                    ></v-select>
                </v-scale-transition>
            </v-flex>
            <!--v-flex(xs6)v-btn(@click="$emit('cancel')", :disabled="loadingSubmit", flat, block) Abbrechen-->
            <v-flex xs12>
                <v-btn
                        block
                        outline
                        :loading="loadingSubmit"
                        :disabled="loadingSubmit || selectedEventStyles === null || selectedEventStyles.length === 0"
                        @click.one="submit"
                >{{ $t('add_registration') }}</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        watch: {
        },
        props: {
            starter: {
                type: Object,
                default: null
            }
        },
        data () {
            return {
                loadingSubmit: false,
                loadingTypes: false,
                loadingAgeGroups: false,
                loadingStyles: false,
                starter_types: [],
                age_groups: [],
                event_styles: [],
                selectedType: null,
                selectedAgeGroup: null,
                selectedEventStyles: null
            }
        },
        mounted() {
            this.loadStarterTypes(this.starter);
        },
        methods: {
            loadStarterTypes(starter) {
                this.loadingTypes = true;
                axios.get(`/api/v1/starters/${starter.id}/possible_types`).then(response => {
                    this.$set(this, 'starter_types', response.data.data);

                    if (this.starter_types.length === 1) {
                        this.$set(this, 'selectedType', this.starter_types[0]);
                        this.starterTypeChanged();
                    }

                    this.loadingTypes = false;

                    if (this.starter_types.length === 0) {
                        this.$store.commit('snackBar', {
                            color: 'info',
                            text: this.$t('no_more_possible_starter_types', [this.starter.name])
                        });
                        this.$emit('cancel')
                    }
                });
            },
            starterTypeChanged() {
                this.loadingAgeGroups = true;
                this.$set(this, 'age_groups', []);
                this.$set(this, 'event_styles', []);

                axios.get(`/api/v1/starters/${this.starter.id}/possible_age_groups`, {
                    params: {
                        starter_type: this.selectedType.id
                    }
                }).then(response => {
                    this.$set(this, 'age_groups', response.data.data);

                    if (this.age_groups.length === 1) {
                        this.$set(this, 'selectedAgeGroup', this.age_groups[0]);
                        this.ageGroupChanged();
                    }

                    this.loadingAgeGroups = false;
                });
            },
            ageGroupChanged() {
                this.loadingStyles = true;
                this.$set(this, 'event_styles', []);

                axios.get(`/api/v1/starters/${this.starter.id}/possible_event_styles`, {
                    params: {
                        starter_type: this.selectedType.id,
                        age_group: this.selectedAgeGroup.id,
                    }
                }).then(response => {
                    this.$set(this, 'event_styles', response.data.data);

                    if (this.event_styles.length === 1 || _.every(this.event_styles, s => s.starter_style_id === null)) {
                        this.$set(this, 'selectedEventStyles', [this.event_styles[0]]);
                    }

                    this.loadingStyles = false;
                });
            },
            submit() {
                this.loadingSubmit = true;
                let event_styles = this.selectedEventStyles;
                axios.post(`/api/v1/starter_registrations`, {
                    starter_id: this.starter.id,
                    age_group_id: this.selectedAgeGroup.id,
                    event_styles: this.selectedEventStyles
                }).then(response => {
                    let starter = _.cloneDeep(this.starter);
                    if (!starter.starter_registrations) {
                        starter.starter_registrations = [];
                    }
                    _.each(response.data.data, r => {
                        starter.starter_registrations.push(r);
                    });
                    starter.add_registration = false;
                    this.loadingSubmit = false;
                    this.$emit('submit', starter);
                });
            }
        }
    }
</script>
